type ExpandableStickyRowsRow<TParent, TChild> =
  | { kind: "parent"; parent: TParent; isExpandable: boolean; isExpanded: boolean }
  | { kind: "child"; parent: TParent; child: TChild };

export const flattenExpandableStickyRows = <TParent, TChild>(
  data: TParent[],
  expandedIds: Set<string>,
  getParentId: (parent: TParent) => string,
  getChildren: (parent: TParent) => TChild[]
): { rows: ExpandableStickyRowsRow<TParent, TChild>[]; stickyRanges: [number, number][] } => {
  const rows: ExpandableStickyRowsRow<TParent, TChild>[] = [];
  const stickyRanges: [number, number][] = [];

  for (const parent of data) {
    const children = getChildren(parent);
    const isExpandable = children.length > 1;
    const isExpanded = isExpandable && expandedIds.has(getParentId(parent));

    const parentIndex = rows.length;
    rows.push({ kind: "parent", parent, isExpandable, isExpanded });

    if (!isExpanded) {
      continue;
    }

    for (const child of children) {
      rows.push({ kind: "child", parent, child });
    }

    // Keep the parent pinned until its whole group of sub-rows scrolls past.
    stickyRanges.push([parentIndex, rows.length - 1]);
  }

  return { rows, stickyRanges };
};
